import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Workflows from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/workflows'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'workflows_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'workflows_list',
          component: Workflows,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':workflowId/edit',
          name: 'workflows_edit',
          component: () => import('./WorkflowEditor.vue'),
          meta: {
            permissions: ['administrator'],
            fullWidth: true,
          },
        },
      ],
    },
  ],
};
